var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomsBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 103,
    viewBox: "0 0 237 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1958 139.485L38.8662 138.146L7.55057 99.0551L5.88018 100.393L37.1958 139.485Z",
    fill: "url(#paint0_linear_3437_43259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4749 65.2783L45.5908 63.3291L11.059 78.9918L11.9431 80.941L46.4749 65.2783Z",
    fill: "url(#paint1_linear_3437_43259)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3437_43259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -25,
    y: 65,
    width: 43,
    height: 43
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-14.8267 68.876C-24.7078 75.1196 -27.6566 88.1913 -21.4129 98.0724C-15.1693 107.954 -2.09763 110.902 7.78348 104.659C17.6646 98.415 20.6133 85.3433 14.3697 75.4622C8.12608 65.5811 -4.94562 62.6323 -14.8267 68.876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3437_43259)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-14.8267 68.876C-24.7078 75.1196 -27.6566 88.1913 -21.4129 98.0724C-15.1693 107.954 -2.09763 110.902 7.78348 104.659C17.6646 98.415 20.6133 85.3433 14.3697 75.4622C8.12608 65.5811 -4.94562 62.6323 -14.8267 68.876Z",
    fill: "url(#paint2_linear_3437_43259)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M2.84895 68.2684C10.6985 70.847 15.4511 77.8353 13.4643 83.8716C11.4775 89.9079 3.50918 92.7105 -4.34034 90.1319C-12.1898 87.5533 -16.9425 80.565 -14.9557 74.5287C-12.9689 68.4924 -5.00056 65.6898 2.85003 68.2721L2.84895 68.2684Z",
    fill: "url(#paint3_radial_3437_43259)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54605 77.2052C10.8489 79.1627 10.954 81.3793 9.78047 82.1615C8.6069 82.9437 6.59962 81.9898 5.29789 80.0359C3.99508 78.0784 3.88989 75.8618 5.06346 75.0796C6.23703 74.2974 8.24432 75.2513 9.54605 77.2052Z",
    fill: "url(#paint4_radial_3437_43259)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3437_43259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 46,
    width: 27,
    height: 27
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8133 53.1815C41.3256 59.5965 43.6986 67.6243 50.1137 71.1121C56.5287 74.5998 64.5565 72.2268 68.0443 65.8117C71.532 59.3967 69.1589 51.3689 62.7439 47.8812C56.3289 44.3934 48.3011 46.7664 44.8133 53.1815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3437_43259)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8133 53.1815C41.3256 59.5965 43.6986 67.6243 50.1137 71.1121C56.5287 74.5998 64.5565 72.2268 68.0443 65.8117C71.532 59.3967 69.1589 51.3689 62.7439 47.8812C56.3289 44.3934 48.3011 46.7664 44.8133 53.1815Z",
    fill: "url(#paint5_linear_3437_43259)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M60.7119 48.0277C65.5715 49.7688 68.4269 54.2075 67.0869 57.9474C65.7506 61.6862 60.7251 63.3063 55.8655 61.5652C51.0058 59.8241 48.1504 55.3854 49.4904 51.6455C50.8268 47.9067 55.8523 46.2866 60.7119 48.0277Z",
    fill: "url(#paint6_radial_3437_43259)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7513 53.7198C65.5347 54.9643 65.5604 56.3496 64.8166 56.8188C64.0729 57.2879 62.8312 56.6617 62.0515 55.4162C61.2681 54.1718 61.2424 52.7864 61.9862 52.3173C62.73 51.8481 63.9716 52.4743 64.7513 53.7198Z",
    fill: "url(#paint7_radial_3437_43259)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1726 70.1835C56.4264 71.0819 55.05 71.5798 53.0953 71.2989C51.1431 71.0133 49.3521 70.0549 49.0983 69.1564C48.8446 68.2579 50.221 67.7601 52.1757 68.0409C54.1279 68.3265 55.9189 69.285 56.1726 70.1835Z",
    fill: "url(#paint8_radial_3437_43259)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.953 93.0517L146.694 94.9961L112.298 90.4279L112.556 88.4835L146.953 93.0517Z",
    fill: "url(#paint9_linear_3437_43259)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3437_43259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 76,
    width: 41,
    height: 40
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.384 114.755C167.765 118.255 179.017 112.677 182.517 102.297C186.017 91.9159 180.439 80.6634 170.059 77.1634C159.678 73.6635 148.425 79.2414 144.925 89.6222C141.425 100.003 147.003 111.255 157.384 114.755Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3437_43259)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.384 114.755C167.765 118.255 179.017 112.677 182.517 102.297C186.017 91.9159 180.439 80.6634 170.059 77.1634C159.678 73.6635 148.425 79.2414 144.925 89.6222C141.425 100.003 147.003 111.255 157.384 114.755Z",
    fill: "url(#paint10_linear_3437_43259)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M145.419 97.6989C144.586 90.0001 148.708 83.2423 154.628 82.6015C160.548 81.9608 166.024 87.6788 166.858 95.3776C167.692 103.076 163.57 109.834 157.646 110.477C151.726 111.118 146.25 105.4 145.416 97.7012L145.419 97.6989Z",
    fill: "url(#paint11_radial_3437_43259)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.462 88.5268C151.627 86.6605 153.483 85.7093 154.603 86.4096C155.724 87.1099 155.687 89.1911 154.524 91.0604C153.359 92.932 151.504 93.8779 150.383 93.1776C149.262 92.4773 149.299 90.3961 150.462 88.5268Z",
    fill: "url(#paint12_radial_3437_43259)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.296 89.3211C179.345 88.3894 180.917 89.9229 181.815 92.745C182.711 95.5694 182.59 98.608 181.544 99.5426C180.495 100.474 178.923 98.9408 178.025 96.1187C177.129 93.2942 177.25 90.2557 178.296 89.3211Z",
    fill: "url(#paint13_radial_3437_43259)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3437_43259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 77,
    width: 22,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.328 77.8362C112.227 78.6375 116.36 84.0699 115.559 89.9696C114.758 95.8694 109.325 100.002 103.426 99.201C97.5258 98.3996 93.3928 92.9673 94.1942 87.0676C94.9955 81.1678 100.428 77.0348 106.328 77.8362Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3437_43259)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.328 77.8362C112.227 78.6375 116.36 84.0699 115.559 89.9696C114.758 95.8694 109.325 100.002 103.426 99.201C97.5258 98.3996 93.3928 92.9673 94.1942 87.0676C94.9955 81.1678 100.428 77.0348 106.328 77.8362Z",
    fill: "url(#paint14_linear_3437_43259)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M94.9986 89.9728C95.5644 94.1414 98.6189 97.1726 101.827 96.734C105.036 96.2953 107.18 92.5709 106.614 88.4023C106.052 84.2303 102.994 81.2025 99.7854 81.6412C96.5769 82.0729 94.4329 85.8042 94.9986 89.9728Z",
    fill: "url(#paint15_radial_3437_43259)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8404 94.1591C99.697 94.9933 100.802 95.2533 101.299 94.7373C101.8 94.2247 101.508 93.1292 100.651 92.295C99.7947 91.4607 98.6894 91.2007 98.1924 91.7168C97.6954 92.2328 97.9838 93.3248 98.8404 94.1591Z",
    fill: "url(#paint16_radial_3437_43259)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.426 90.1167C114.098 90.4697 114.732 89.4569 114.833 87.8529C114.937 86.2453 114.478 84.658 113.802 84.3015C113.129 83.9485 112.495 84.9613 112.395 86.5653C112.294 88.1694 112.75 89.7603 113.426 90.1167Z",
    fill: "url(#paint17_radial_3437_43259)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3437_43259",
    x1: 23.2321,
    y1: 118.618,
    x2: 21.5588,
    y2: 119.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3437_43259",
    x1: 28.3491,
    y1: 71.1495,
    x2: 29.2348,
    y2: 73.1021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3437_43259",
    x1: 6.85823,
    y1: 68.3169,
    x2: -13.8986,
    y2: 105.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#79A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6C89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#647AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6275FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#575BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4F4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4D44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4D44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4F49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#565AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6275FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6276FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6F90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#79A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#7FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B2FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.260601 79.4544) rotate(108.202) scale(11.534 14.9942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C00B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2C00B5",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2C00B5",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C00B5",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C00B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.3449 78.5004) rotate(146.332) scale(2.55392 4.26504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3437_43259",
    x1: 63.212,
    y1: 48.152,
    x2: 49.6493,
    y2: 70.8567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E57DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#DE6EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#DC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D65DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C941FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C030FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C02FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C840FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DE6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E782FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EC8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE91FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9142 55.0349) rotate(109.702) scale(7.2041 9.36533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE2AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BE2AFF",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BE2AFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BE2AFF",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BE2AFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3478 54.4773) rotate(147.832) scale(1.59382 2.66169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.605 112.303) rotate(8.27224) scale(3.5646 1.54655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3437_43259",
    x1: 129.471,
    y1: 92.7336,
    x2: 129.729,
    y2: 90.7892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A84C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DEDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B4B0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9590CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A84C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3437_43259",
    x1: 143.983,
    y1: 94.2348,
    x2: 183.503,
    y2: 97.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D9D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#CDC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C9BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BDADFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A691F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9880F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#947AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#947AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#987FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#A690F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BBABFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C9BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D7CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E0D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DDFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.221 95.873) rotate(-6.18795) scale(10.8062 14.048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#947AF7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#947AF7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#947AF7",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#947AF7",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#947AF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.469 89.8217) rotate(31.952) scale(2.39074 3.99254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.3084 -162.101) rotate(-107.608) scale(5.35048 2.32137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3437_43259",
    x1: 94.6593,
    y1: 92.0193,
    x2: 115.059,
    y2: 85.0568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B14EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#A236FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9827FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9522FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8C19EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7F0BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7602BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7400B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7400B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7602BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7E0ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8B18EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9522FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B2CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A73FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B14EFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.499 90.2549) rotate(-7.68478) scale(5.87247 7.63422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7400B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7400B9",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7400B9",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7400B9",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7400B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.5822 93.0707) rotate(-45.8248) scale(1.29939 2.16998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3437_43259",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.6475 560.594) rotate(93.7352) scale(2.90407 1.25997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsBottom);
export default __webpack_public_path__ + "static/media/atoms-bottom.d599c00a13d4e9229f9a5a836814bac1.svg";
export { ForwardRef as ReactComponent };